import { render, staticRenderFns } from "./PassengersData.vue?vue&type=template&id=d52470c8&scoped=true&"
import script from "./PassengersData.vue?vue&type=script&lang=js&"
export * from "./PassengersData.vue?vue&type=script&lang=js&"
import style0 from "./PassengersData.vue?vue&type=style&index=0&id=d52470c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52470c8",
  null
  
)

export default component.exports